<lib-select
  [style.height.%]="100"
  [options]="clientOptions()"
  [formControl]="control"
  [labelTranslateKey]="labelTranslateKey"
  [searchTranslateKey]="searchTranslateKey"
  [isClearable]="isClearable"
  [fullWidth]="fullWidth"
  [isSearchDisplayed]="true"
  [isOptionListLoading]="clientDictionaryService.isLoading()"
  (scrolled)="loadMore()"
  (searchKeyChange)="onKeywordChange($event)"
/>
